export const FETCH_SEARCH_POSTS_RESULTS = 'FETCH_SEARCH_POSTS_RESULTS';
export const FETCH_SEARCH_POSTS_RESULTS_SUCCESS = 'FETCH_SEARCH_POSTS_RESULTS_SUCCESS';
export const FETCH_SEARCH_POSTS_RESULTS_FAILURE = 'FETCH_SEARCH_POSTS_RESULTS_FAILURE';

export const SET_COMMUNITY_FILTER = 'SET_COMMUNITY_FILTER';

export const SET_SEARCH_SORT_BY = 'SET_SEARCH_SORT_BY';



// WEBPACK FOOTER //
// ./src/modules/search/actionTypes.js